import { FulfillmentGroupData } from "@redotech/redo-fulfillment-group-common/fulfillment-group";
import { SortDirection } from "@redotech/redo-views-common/table";
import { RedoTableTextCell } from "@redotech/redo-web/arbiter-components/tables/redo-table-cells";
import { ColumnAlignment } from "@redotech/redo-web/table";
import { Column2 } from "@redotech/redo-web/table2";

const customStringKeys = [
  "customString1",
  "customString2",
  "customString3",
  "customAttributeString1",
  "customAttributeString2",
  "customAttributeString3",
] as const;

export function CustomStringColumn({
  title,
  key,
}: {
  title: string;
  key: (typeof customStringKeys)[number];
}): Column2<FulfillmentGroupData> {
  return {
    alignment: ColumnAlignment.LEFT,
    key,
    title,
    renderNormalCell: ({ row }: { row: FulfillmentGroupData }) => (
      <RedoTableTextCell text={row[key] ? row[key].join(", ") : ""} />
    ),
    width: 120,
    sort: SortDirection.DESC,
  };
}
